import axios from "axios";
//#region src/api.sitecore/core.axios.ts
var sitecoreAxios = axios.create();
var sitecoreAuthz = {
	isAuthorized: false,
	authenticationProvider: "UniLogin",
	userRole: "None"
};
var deferredRequests = /* @__PURE__ */ new Set();
var deferringInterceptor = sitecoreAxios.interceptors.request.use((config) => {
	return new Promise((resolve) => {
		deferredRequests.add((middleware) => resolve(middleware(config)));
	});
});
/**
* apply a request interceptor that will inject configurations needed for
* requests to the PM2 SiteCore backend to be handled correctly
*/
function applyAuthzInterceptor(authz) {
	sitecoreAuthz = authz;
	sitecoreAxios.interceptors.request.eject(deferringInterceptor);
	sitecoreAxios.interceptors.request.use(applyConfig);
	deferredRequests.forEach((cb) => cb(applyConfig));
	function applyConfig(config) {
		config.headers["X-PM2-Authentication-Type"] = authz.authenticationProvider;
		config.headers["X-PM2-Authorized"] = String(authz.isAuthorized);
		config.headers["X-PM2-User-Role"] = authz.userRole;
		return config;
	}
}
/**
* if enabled, this forces all requests to run through the preview API,
* regardless of otherwise configured base url forces all requests to run
*/
function applyPreviewInterceptor() {
	sitecoreAxios.interceptors.request.use((config) => {
		var _config$url;
		config.url = (_config$url = config.url) === null || _config$url === void 0 ? void 0 : _config$url.replace(process.env["PM2_API"] ?? "", process.env["PM2_PREVIEW_API"] ?? "");
		return config;
	});
}
/**
* apply a request interceptor that will inject a signature to the request, so
* that SiteCore can authenticate it (this is inteded for usage in ServerSide
* environments where requests aren't auto-intercepted by Gateway)
*
* @note this interceptor must be applied after the core interceptor in order
*       to be able to generate the correct, expected signature
*/
function applySiteCoreSigningInterceptor(buildSignature) {
	sitecoreAxios.interceptors.request.use((config) => {
		const { signature, tstamp } = buildSignature({
			url: config.url ?? "",
			authz: {
				isAuthorized: !!config.headers["X-PM2-Authorized"],
				authenticationProvider: config.headers["X-PM2-Authentication-Type"] ?? "",
				userRole: config.headers["X-PM2-User-Role"]
			}
		});
		config.headers["Authorization"] = signature;
		config.headers["X-PM2-Authenticated-At"] = tstamp;
		return config;
	});
}
function authzToQueryKeySegments(input) {
	return [
		input.userRole,
		input.isAuthorized,
		input.authenticationProvider
	];
}
//#endregion
export { applyAuthzInterceptor, applyPreviewInterceptor, applySiteCoreSigningInterceptor, authzToQueryKeySegments, sitecoreAuthz, sitecoreAxios };

//# sourceMappingURL=core.axios.js.map